import { validateAFM, validatePhoneNumber } from "utils";

export const formFields1 = [
  {
    label: 'Ονομα',
    id: 'firstName',
    type: 'text',
    name: 'firstName',
    size: 'large',
    placeholder: 'Εισάγετε Όνομα',
    // containerClassName: 'register-custom-field-grey custom-padding',
    span: 8,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    //   { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
    disabled: false,
  },
  {
    label: 'Επώνυμο',
    id: 'lastName',
    type: 'text',
    name: 'lastName',
    size: 'large',
    placeholder: 'Εισάγετε Επώνυμο',
    // containerClassName: 'register-custom-field-grey',
    span: 8,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    //   { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
    disabled: false,
  },
  {
    label: 'ΑΦΜ Eπιχείρησης',
    id: 'companyVat',
    type: 'text',
    name: 'companyVat',
    size: 'large',
    placeholder: 'Εισάγετε ΑΦΜ',
    // containerClassName: 'register-custom-field-grey',
    span: 8,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    //   { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    () => ({
        validator(_, value) {
          return value ? validateAFM(value.toString()) : Promise.resolve();
        },}),   
    ],
    asterisk: true,
    disabled: false,
  },
  {
    label: 'Επωνυμία Επιχείρησης',
    id: 'companyName',
    type: 'text',
    name: 'companyName',
    size: 'large',
    placeholder: 'Εισάγετε Επωνυμία Επιχείρησης',
    // containerClassName: 'register-custom-field-grey',
    span: 24,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    //   { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },    
    ],
    asterisk: true,
    disabled: false,
  },
  {
    label: 'Μέγεθος Επιχείρησης',
    id: 'companySize',
    type: 'businessSize',
    name: 'companySize',
    span: 24,
    bold: true,
    // containerClassName: 'register-custom-field',
    defaultValue: '',
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Ημερομηνία Ίδρυσης',
    type: 'date',
    id: 'foundingDate',
    name: 'foundingDate',
    allowClear: true,
    size: 'large',
    placeholder: 'Εισάγετε Ημερομηνία Ίδρυσης',
    className: 'w-100 like-text',
    span: 8,
    asterisk: true,
    iconPlacement: 'left',
    // containerClassName: 'register-custom-field-grey',
    // disabledDate: d => !d || d.isAfter('2010-12-31'), //|| d.isBefore('2012-01-01') || 
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    ],
  },
  {
    label: 'Τηλέφωνο',
    id: 'phone',
    type: 'text',
    name: 'phone',
    size: 'large',
    placeholder: 'Εισάγετε Τηλέφωνο',
    // containerClassName: 'register-custom-field-grey',
    maxLength: 10,
    span: 8,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
            validator(_, value) {
              return validatePhoneNumber(value, false);
            },
          }),
    ],
    asterisk: true,
    disabled: false,
  },
    {
    label: 'Email',
    id: 'email',
    type: 'text',
    name: 'email',
    size: 'large',
    placeholder: 'Εισάγετε Email',
    // containerClassName: 'register-custom-field-grey emaillll',
    span: 8,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { type: 'email', message: 'Αυτό που εισάγετε δεν είναι έγκυρη διεύθυνση e-mail'}
    ],
    asterisk: true,
    disabled: false,
  },
];

export const formFields2 = [
  {
    label: 'Κείμενο',
    id: 'text',
    type: 'textarea',
    name: 'text',
    size: 'large',
    placeholder: 'Εισάγετε Κείμενο',
    containerClassName: 'register-custom-field',
    rows: 12,
    simple: true,
    span: 24,
    maxLength: 1000,
    rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        { max: 999 , message: 'Το πεδίο μπορεί να έχει το πολύ 1000 χαρακτήρες' },
    ],
    asterisk: true,
}, 
];